export type ShortcutSuccess = {
  success: true
  shortcuts_html: string
  shortcut_id: number
}

export type ShortcutFallback = {
  require_fallback: true
}

export type ShortcutError = {
  error: string
}

export type ShortcutResponse = ShortcutSuccess | ShortcutFallback | ShortcutError

export async function addShortcut(
  slug: string,
  csrf: string,
  payload: { menu_app_id: number | null; fallback_section_id?: string }
): Promise<ShortcutResponse | null> {
  try {
    const res = await fetch(`/projects/${slug}/add_shortcut`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
      body: JSON.stringify(payload)
    })
    return await res.json()
  } catch {
    return null
  }
}
